module.exports = __webpack_public_path__ + "img/Delivery-Truck.dcb18742.jpg";